import './development.css';

function DevelopmentTeam() {
    return ( 
        <div className="development">
            <span className="development_by">Desenvolvido Por</span>
            <span className="development_team">APÉ</span>
        </div>
     );
}

export default DevelopmentTeam;